/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactShareCandidateResponse } from '../../models/contact-share-candidate-response';

export interface GetContactShareCandidates$Params {
  id: number;
}

export function getContactShareCandidates(http: HttpClient, rootUrl: string, params: GetContactShareCandidates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactShareCandidateResponse>>> {
  const rb = new RequestBuilder(rootUrl, getContactShareCandidates.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactShareCandidateResponse>>;
    })
  );
}

getContactShareCandidates.PATH = '/contacts/{id}/share-candidates';
